import type { FC, SVGProps } from 'react';

export const XlsxIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="14"
    height="14"
    fill="currentColor"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6227_23675)">
      <path
        fill="currentColor"
        d="M8.63733 0C8.77007 4.9831e-05 8.89616 0.0537549 8.98987 0.147461L12.3531 3.50977C12.4467 3.60349 12.4996 3.73159 12.4996 3.86426V13.5C12.4996 13.7766 12.2762 14 11.9996 14H1.99963C1.72307 14 1.49963 13.7766 1.49963 13.5V0.5C1.49972 0.223517 1.72313 4.13911e-06 1.99963 0H8.63733ZM2.62463 1.125V12.875H11.3746V5.15625H7.99963C7.82559 5.15625 7.65884 5.08694 7.53577 4.96387C7.41275 4.8408 7.34338 4.67401 7.34338 4.5V1.125H2.62463ZM5.90588 6.37402C5.97144 6.37402 6.03262 6.40772 6.06702 6.46387L7.03284 8.06445L7.98889 6.46582C8.02327 6.40961 8.08442 6.375 8.15002 6.375H8.70764C8.7412 6.3752 8.77452 6.38417 8.80334 6.40137C8.83204 6.41853 8.85562 6.44335 8.8717 6.47266C8.88778 6.50211 8.89525 6.5358 8.89417 6.56934C8.89305 6.60294 8.88291 6.63569 8.86487 6.66406L7.53284 8.73438L8.84534 10.7725C8.90118 10.8599 8.87598 10.9751 8.7887 11.0312C8.75745 11.05 8.72307 11.0615 8.68713 11.0615H8.1012C8.03714 11.0615 7.97639 11.0279 7.94202 10.9717L6.96838 9.3877L5.98889 10.9736C5.95458 11.0282 5.89518 11.0624 5.82971 11.0625H5.29065C5.25713 11.0624 5.22381 11.0532 5.19495 11.0361C5.16618 11.0191 5.14182 10.9951 5.12561 10.9658C5.10947 10.9366 5.10139 10.9035 5.10217 10.8701C5.10301 10.8367 5.11292 10.8038 5.13049 10.7754L6.4342 8.7002L5.14807 6.66309C5.09186 6.57408 5.11832 6.45805 5.20569 6.40332C5.23538 6.38301 5.27034 6.37402 5.30627 6.37402H5.90588ZM8.40588 4.09375H11.3463L8.40588 1.15332V4.09375Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_6227_23675">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
